export default "__VITE_ASSET__CjE6kxGB__"